export default class BaseError extends Error {
    constructor(message, originalError) {
        super(message);
        this.originalError = originalError;
    }
}
